﻿import { createListenerMiddleware, addListener } from '@reduxjs/toolkit';
import { AppDispatch } from '../store';
import { RootState } from '../slices';

export const listenerMiddleware = createListenerMiddleware();
export const startAppListening = listenerMiddleware.startListening.withTypes<RootState, AppDispatch>();
export const addAppListener = addListener.withTypes<RootState, AppDispatch>();
